const l = /^(\w+:\/\/[^/?]+)?(.*?)(\?.+)?$/, o = (n) => n.filter(
  (e) => e != null && e !== !1 && (typeof e == "string" || typeof e == "number")
).map((e) => `${e}`).filter((e) => e), i = (n) => {
  const e = n.join("/"), [, r = "", t = ""] = e.match(l) ?? [];
  return {
    prefix: r,
    pathname: t.split("/").filter((s) => s !== "")
  };
}, a = (n) => {
  const { prefix: e, pathname: r } = n;
  let t = e;
  return r.length > 0 ? (t ? t += "/" : t = "/", t += r.join("/")) : t || (t = "/"), t;
}, f = (...n) => {
  const e = o(n), r = i(e);
  return a(r);
};
export {
  f as j
};
//# sourceMappingURL=joinUrl-BTy9bvoK.js.map
